import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@Sage/hoi-poi-ui';
import { t } from 'utils/getLiteral';
import './styles.scss';

/**
 * General component description.
 */

const ImplementationsModal = memo(({ isOpen, closeModal = () => null, children }) => {
    return (
        <Modal
            width="1000px"
            title={t('cfm_label_choose_implementation')}
            className="implementations-modal"
            classes={{ content: `implementations-modal-body` }}
            overlayClassName={'implementations-modal-overlay'}
            isOpen={isOpen}
            onRequestClose={closeModal}
        >
            {children}
        </Modal>
    );
});

ImplementationsModal.propTypes = {
    /** Description of prop "children". */
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    /** Indicate if modal is opened */
    isOpen: PropTypes.bool,
    /** Function to call when close modal */
    closeModal: PropTypes.func,
};

export default ImplementationsModal;
